goog.provide('el8.ptdata.hl7Messages');

goog.require('el8.model.base');
goog.require('el8.service.urls');

/**
 * This document backs a chart feed item for an Hl7 Mesage upload,
 * which can be viewed in a dialog from the patient chart
 */
el8.ptdata.hl7Messages = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addStringProperty('downloadUrl'); // to get back the raw Hl7
    _class.addIntProperty('dataFormat');


    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        deleteFn: function(var_args) { return el8.ptdata.documentDeleteFn.apply(that, arguments); }
    });

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        delete mapped['signUserBehalfId'];
        mapped['signUserBehalfName'] = this.getSignUserBehalfName();

        delete mapped['signUserId'];
        mapped['signUserName'] = this.getSignUserName();
        mapped['signUserType'] = this.getSignUserType();

        return mapped;
    };

    // _class.prototype.sign = function(opts) {
    //     opts = opts || {};
    //     var postDict = {};
    //     if (!el8.util.isNone(opts.doImport)) { postDict.do_import = opts.doImport; }
    //     if (!el8.util.isNone(opts.behalfUserId)) { postDict.behalf_user_id = opts.behalfUserId; }
    //
    //     $.el8_ajax({
    //         type: 'POST',
    //         data: JSON.stringify(postDict),
    //         url: el8.service.urls.get('signXmlSummary', [this]),
    //         success: function(data) {
    //             var updatedSummary = that.create(data.xml_summary);
    //             if (opts.successCb) { opts.successCb(updatedSummary, data); }
    //         },
    //         complete: function() {
    //             if (opts.completeCb) { opts.completeCb(); }
    //         }
    //     });
    // };

    return that;

})();
